import { render, staticRenderFns } from "./display-options-modal.vue?vue&type=template&id=c7851bec"
import script from "./display-options-modal.ts?vue&type=script&lang=ts&external"
export * from "./display-options-modal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports